var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5C3.36739 10.5 3.24021 10.4473 3.14645 10.3536C3.05268 10.2598 3 10.1326 3 10V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5V1.5C0 1.23478 0.105357 0.98043 0.292893 0.792893C0.48043 0.605357 0.734784 0.5 1 0.5H9C9.26522 0.5 9.51957 0.605357 9.70711 0.792893C9.89464 0.98043 10 1.23478 10 1.5V7.5C10 7.76522 9.89464 8.01957 9.70711 8.20711C9.51957 8.39464 9.26522 8.5 9 8.5H5.95L4.1 10.355C4 10.45 3.875 10.5 3.75 10.5H3.5Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLight);
export default __webpack_public_path__ + "static/media/message_light.21aa97b1c388aeee383fcad319775706.svg";
export { ForwardRef as ReactComponent };